module.exports = __webpack_public_path__ + "dgdp-7765aa7a.webp";